export const notification = ({isOpen,message,bg_color}) => {
    return{
        type: "OPEN-OR-CLOSE-NOTIFICATION",
        isOpen : isOpen,
        message : message,
        bg_color : bg_color
    }
}